export default __webpack_public_path__ + "static/media/excel2.0a1364e2.svg";